import { RenderFieldExtensionCtx } from 'datocms-plugin-sdk';
import { Canvas } from 'datocms-react-ui';
import TripFetcher from '../components/TripFetcher';

type PropTypes = {
  ctx: RenderFieldExtensionCtx;
};

export default function FieldExtension({ ctx }: PropTypes) {
  const { apiEndpoint, authorizationKey } = ctx.plugin.attributes.parameters;
  
  if(!apiEndpoint || !authorizationKey) {
    return (
      <Canvas ctx={ctx}>      
        <p>Endpoint or (and) API Key is missing.<br/>Please finish setting up the plugin.</p>
      </Canvas>
    )
  }

  return (
    <Canvas ctx={ctx}>
      <TripFetcher ctx={ctx} />
    </Canvas>
  );
}